var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col min-h-screen overflow-hidden"},[_c('StreamBackdrop',{staticClass:"flex-grow"}),_c('BottomLedge')],1)}
var staticRenderFns = []

export { render, staticRenderFns }